// i18next-extract-mark-ns-start LandingAds

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SecondTitle, tabletThresholdPixels, frames } from '../home/v4/styledComponents';

type TextPropsType = {
  uppercase?: boolean;
  width?: boolean;
  fontSize?: number;
  center?: boolean;
};

const Container = styled.div`
  display: flex;
  max-width: 1180px;
  margin: 128px 0;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: calc(100vw - 48px);
    margin: 40px ${frames.mobile};
    gap: 40px;
  }
`;
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  max-width: 100%;
`;
const Text = styled.p<TextPropsType>`
  margin: 0;
  font-size: ${(props) => props.fontSize}px;
  text-align: center;
  ${(props) => props.uppercase && 'text-transform: uppercase;'};
  ${(props) => props.width && 'width: 550px;'};
  max-width: 100%;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
  }
`;

function IntroLP({ arrondissement, locality }: { arrondissement?: string; locality?: string }) {
  const { t } = useTranslation();

  const title = locality ? `Tilli facilite l‘accès aux réparations à ${locality} ${arrondissement || ''}` : 'Tilli facilite l‘accès aux réparations';

  return (
    <Container>
      <SecondTitle monospace center>{title}</SecondTitle>
      <TextBlock>
        <Text uppercase fontSize={20}>{t('Faites réparer vos vêtements, chaussures, maroquinerie et décoration.')}</Text>
        <Text width fontSize={16}>
          {t(`Nos artisans experts réparent vos vêtements, vos chaussures, vos sacs, vos accessoires et votre linge de maison partout en France.
          Faites rapidement votre devis en ligne et profitez des réductions du Bonus Réparation.`)}
        </Text>
      </TextBlock>
    </Container>
  );
}

IntroLP.defaultProps = {
  arrondissement: '',
  locality: '',
};

export default IntroLP;
